import React, { useState } from 'react';
import { Box, Grid, ChakraProvider, Button } from '@chakra-ui/react';
import theme from '../../config/themeSeeker';
import Header from '../../components/admin/header';
import Sidebar from '../../components/admin/sideBar';
import CertificatePool from '../../components/admin/CertificatePool';
import IssuingAuthoritiesPool from '../../components/admin/IssuingAuthoritiesPool';
import SpecializationPool from '../../components/admin/SpecializationPool';
import CountriesPool from '../../components/admin/CountriesPool';
import CertificateSpecializationRelation from '../../components/admin/CertificateSpecializationRelation';
import CertificateManualVerification from '../../components/admin/CertificateManuelVerificationComponent'; // Import the new component
import Welcome from '../../components/admin/Welcome'; // Import the Welcome component
import PaymentTracking from '../../components/admin/PaymentTracking';

const AdminHome = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedPool, setSelectedPool] = useState('welcome');

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleSelectItem = (item) => {
    setSelectedPool(item);
  };

  const renderPoolComponent = () => {
    switch (selectedPool) {
      case 'certificatePool':
        return <CertificatePool />;
      case 'authoritiesPool':
        return <IssuingAuthoritiesPool />;
      case 'specializationPool':
        return <SpecializationPool />;
      case 'countriesPool':
        return <CountriesPool />;
      case 'certificateSpecializationRelation':
        return <CertificateSpecializationRelation />;
      case 'certificateManualVerification':
        return <CertificateManualVerification />;
      case 'welcome':
        return <Welcome />;
      case 'paymentTracking':
        return <PaymentTracking isAdmin={true} />;
      default:
        return null;
    }
  };

  return (
    <ChakraProvider theme={theme}>
      <Box position="relative" h="100vh">
        <Box
          position="fixed"
          left='0'
          top='0'
          zIndex='3'
          w={isSidebarOpen ? '300px' : '0'}
          h='100vh'
          bg="white"
          overflow='hidden'
          transition="width 0.3s ease-in-out"
        >
          {isSidebarOpen && (
            <Sidebar onSelectItem={handleSelectItem} selectedItem={selectedPool} />
          )}
        </Box>

        <Button
          position="fixed"
          top="10px"
          left={isSidebarOpen ? '300px' : '0'}
          zIndex="4"
          colorScheme="teal"
          onClick={toggleSidebar}
          size="sm"
          width="40px"
          borderLeftRadius="0"
        >
          {isSidebarOpen ? '<' : '>'}
        </Button>

        <Grid
          templateAreas={`"header"
                          "profileOverview"
                          "bar"
                          "main"`}
          gridTemplateRows={'50px 40% auto 1fr'}
          gridTemplateColumns={'1fr'}
          h='100vh'
          ml={isSidebarOpen ? '300px' : '0'}
          transition="margin-left 0.3s ease-in-out"
          overflowY="auto"
        >
          {renderPoolComponent()}
        </Grid>
      </Box>
    </ChakraProvider>
  );
};

export default AdminHome;